import { getState } from '~src/state';

export const changeObjectProperty = (property, value) => {
  let activeObject = getState('activeObject');
  if (activeObject.type === 'MagicFrame') {
    activeObject = activeObject.editingImg;
    if (!activeObject) {
      return;
    }
  }
  activeObject.set(property, value);
  window.canvas.renderAll();
};
